import { useEffect } from 'react';

type KeyCombo = {
	key: string;
	ctrlKey?: boolean;
	altKey?: boolean;
	shiftKey?: boolean;
	metaKey?: boolean;
};

const UseKeyBoardShortCut = (
	element: HTMLElement | React.RefObject<HTMLElement> | string,
	keyCombo: KeyCombo,
	action: (element: HTMLElement | Document | React.RefObject<HTMLElement>) => void,
) => {
	useEffect(() => {
		const handleKeyDown = (event: KeyboardEvent) => {
			const targetElement =
				typeof element === 'string'
					? document.querySelector(element)
					: element instanceof HTMLElement
					  ? element
					  : element.current;
			const { key, ctrlKey, altKey, shiftKey, metaKey } = keyCombo;

			if (
				event.key.toLowerCase() === key.toLowerCase() &&
				event.ctrlKey === (ctrlKey ?? false) &&
				event.altKey === (altKey ?? false) &&
				event.shiftKey === (shiftKey ?? false) &&
				((metaKey && event.metaKey) || (!metaKey && event.ctrlKey)) &&
				!event.repeat
			) {
				event.preventDefault();
				action(targetElement as HTMLElement | Document | React.RefObject<HTMLElement>);
			}
		};

		document.addEventListener('keydown', handleKeyDown);

		return () => {
			document.removeEventListener('keydown', handleKeyDown);
		};
	}, [keyCombo, action]);
};

export default UseKeyBoardShortCut;
